export const CATEGORIES = ["הרפתקאות",/* "ילדים ונוער", */"מדע בדיוני", "הומור וסאטירה", 'טבע ובע"ח', "לימוד", "יהדות"];